import { render, staticRenderFns } from "./BCXFormValues.vue?vue&type=template&id=397c2d7e&scoped=true"
import script from "./BCXFormValues.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXFormValues.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXFormValues.vue?vue&type=style&index=0&id=397c2d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397c2d7e",
  null
  
)

export default component.exports